import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { ApiDigitalAuthAuthentication } from '../../services/auth/authentication.service';
import { Error } from '../../models/error.model';
import { GlobalSwal } from '../../styles/swal.style';
import { Message } from '../../models/message.model';
import { getError, getMessage } from '../../languages/translations/response';
import { authApiKey, authClear, authController } from '../../scripts/authentication.script';
import { errorWebHandler } from '../../scripts/error.web.handler.script';

export interface ValidationPageProps {};

let errorResponse: Error, messageResponse: Message;

const ValidationPage: React.FunctionComponent<ValidationPageProps> = props => {
  const {lang} = StateLanguage()
  const params = useParams()
  const navigate = useNavigate()

  const [mounted, setMounted] = useState(false)

  const loadVerificationAccount = async (token: string) => {
    await ApiDigitalAuthAuthentication.verifyEmail(authApiKey(), token).then( (response) => {
      if (response.status === 200) {
        messageResponse = response.data

        if (authController()) {
          GlobalSwal.fire({
            title: getMessage(messageResponse.message, lang.code),
            text: lang.labels.validatedAccountForLoggedInUser,
            icon: 'success',
            showConfirmButton: false,
            timer: 2200
          }).then( () => {
            navigate('/main/welcome', {replace: true})
          })
        } else {
          GlobalSwal.fire({
            title: getMessage(messageResponse.message, lang.code),
            text: lang.labels.validatedVerifiedForAUserWhoHasNotLoggedIn,
            icon: 'warning',
            showConfirmButton: false,
            timer: 2200
          }).then( () => {
            authClear()
            navigate('/auth/login', {replace: true})
          })
        }
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        }).then( () => {
          authClear()
          navigate('/', {replace: true})
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    })
  }

  const executeReloadPage = () => {
    navigate(0)
  }

  useEffect( () => {
    setMounted(true)

    if (params.token) {
      loadVerificationAccount(params.token)
    }

    return () => setMounted(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!mounted) return null

  return (
    <div className="py-10">
      <h1 className="fs-3qx text-dark text-capitalize mb-5">{lang.labels.verificationYourAccount}</h1>
      <div className="fs-3 fw-bold text-muted mb-10">
        {lang.labels.heWantsAccessApplicationLink},
        <br />
        {lang.labels.waitAMomentToVerifyYourAccess}
      </div>
      <div className="text-center my-10">
        <section className="global">
          <div className="global-top mask">
            <div className="plane"></div>
          </div>
          <div className="global-middle mask">
            <div className="plane"></div>
          </div>
          <div className="global-bottom mask">
            <div className="plane"></div>
          </div>
          <p className="global-text">
            <i>{lang.labels.loading}</i>
          </p>
        </section>
      </div>
      <div className="d-flex justify-content-center fs-5">
        <span className="fw-bold text-secondary">{lang.labels.doesItTakeALongTimeToLoadTheApp}</span>
        <span className="btn btn-link link-primary p-0 ms-1" onClick={executeReloadPage}>{lang.labels.reload}</span>
      </div>
    </div>
  )
};

export default ValidationPage;
